import { useEffect } from "react";

const useReloadChannelSight = (obj) => {
  useEffect(() => {
    if (obj) {
      const event = new CustomEvent("reload-channelsight");
      document.dispatchEvent(event);
    }
  }, [obj]);
};

export default useReloadChannelSight;
